import Vue from 'vue'

export default {
  getYear: (state) => {
    return state.year
  },
  getMonth: (state) => {
    return state.month
  },
  getEvents: (state) => {
    if (state.events[state.year] === undefined) {
      Vue.set(state.events, state.year, [])
    }
    return state.events[state.year][state.month]
  },
  getAllEvents: (state) => {
    const events = []
    for (const year in state.events) {
      for (const month in state.events[year]) {
        for (const event of state.events[year][month]) {
          if (!events.find((e) => {
            return e.id === event.id
          })) {
            events.push(event)
          }
        }
      }
    }
    return events
  },
  getView: state => {
    return state.mobile
  },
  getCalendars: state => {
    return state.calendars
  },
  getCalendarStatus: state => {
    return state.calendarStatus
  },
  getEventsStatus: (state, {
    month,
    year
  }) => {
    return state.states[`${('0' + month).slice(-2)}.${year}`]
  },
  getEventStatusCurrentMonth: (state) => {
    return state.states[`${('0' + state.month).slice(-2)}.${state.year}`]
  },
  getCurrentMonthIsLoading: (state, getters) => {
    return getters.getEventStatusCurrentMonth === 'pending'
  }
}
